
    <div class="register-container">
        <div class="register-card">
            <h1 class="register-title">Register</h1>
            
            <div class="form-group">
                <label class="form-label">Mobile Number</label>
                <input 
                    class="form-input" 
                    type="tel"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    placeholder="Enter your mobile number"
                    [(ngModel)]="registerData.username" 
                />
                <div class="form-hint">Example: 4915212345678</div>
            </div>
            
            <div class="form-group">
                <label class="form-label">PIN</label>
                <input 
                    class="form-input"
                    autocomplete="new-password"
                    type="password"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    placeholder="Enter your personal 4-digit Tantum PIN"
                    [(ngModel)]="registerData.password"
                />
            </div>
            
            <div class="form-group">
                <label class="form-label">Re-enter PIN</label>
                <input 
                    class="form-input" 
                    type="password" 
                    autocomplete="new-password"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    placeholder="Enter your PIN again"
                    [(ngModel)]="registerData.password1"
                />
            </div>

            <!-- Consent Checkboxes -->
            <div class="consent-group">
                <label class="consent-checkbox">
                  <input type="checkbox" class="consent-input" required [(ngModel)]="consentChecked">
                  <span class="consent-text">
                    I agree to the <a href="https://tantumpay.com/en/terms-and-conditions/" target="_blank" rel="noopener noreferrer">terms and conditions</a> and to the processing of my identification data and biometric data for the purpose of carrying out the identification and verification process in accordance with the provisions in the <a href="https://tantumpay.com/en/privacy-policy/" target="_blank" rel="noopener noreferrer">privacy policy</a>.
                  </span>
                </label>
            </div>

            <button class="register-button" (click)="register()" type="submit" [disabled]="!consentChecked">
                Register
            </button>
             <div class="action-links">
                <button class="register-link" (click)="login()" type="button">
                    Already have an account? Login
                </button>
            </div>
            <ngx-spinner size="medium" [type]="typeSelected"></ngx-spinner>
        </div>
    </div>